export const AVAILABLE_EQUIPMENT_STATUS = 'Available';
